import { render } from "./ButtonsContent.vue?vue&type=template&id=c62478ca"
import script from "./ButtonsContent.vue?vue&type=script&lang=js"
export * from "./ButtonsContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__